import { render, staticRenderFns } from "./JoszakiGroupButton.vue?vue&type=template&id=435c60c4"
import script from "./JoszakiGroupButton.vue?vue&type=script&lang=js"
export * from "./JoszakiGroupButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports